var _path, _path2, _mask, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.176 3.456H6.536L5.24 10H3.256L1.96 3.456H3.328L4.248 8.432L5.176 3.456ZM6.11644 10L7.30044 3.456H9.27644L10.4524 10H9.10044L8.90044 8.688H7.66844L7.47644 10H6.11644ZM7.88444 7.256H8.68444L8.28444 4.616L7.88444 7.256ZM13.3031 4.936H12.3831C12.3724 5.41067 12.3644 5.89333 12.3591 6.384C12.3537 6.86933 12.3511 7.39467 12.3511 7.96C12.3511 8.32267 12.3511 8.616 12.3511 8.84C12.3511 9.05867 12.3511 9.24 12.3511 9.384C12.3511 9.52267 12.3511 9.63733 12.3511 9.728C12.3564 9.81333 12.3591 9.904 12.3591 10H11.0151C11.0204 9.76533 11.0257 9.52267 11.0311 9.272C11.0364 9.016 11.0391 8.74133 11.0391 8.448C11.0444 8.14933 11.0471 7.82933 11.0471 7.488C11.0524 7.14133 11.0551 6.76 11.0551 6.344C11.0551 6.04 11.0551 5.776 11.0551 5.552C11.0551 5.328 11.0524 5.12267 11.0471 4.936H10.1271V3.456H13.3031V4.936Z",
    fill: "#6F9FE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.765 11.062L13.133 9.206H13.981L13.597 11.062H14.517L14.885 9.206H15.741L15.357 11.062H16.357V11.91H15.181L14.973 12.934H16.117V13.782H14.797L14.389 15.75H13.597L13.981 13.782H13.037L12.629 15.75H11.845L12.229 13.782H11.261V12.934H12.397L12.597 11.91H11.501V11.062H12.765ZM13.213 12.934H14.149L14.349 11.91H13.421L13.213 12.934Z",
    fill: "#6F9FE9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_11322_7928",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 1,
    stroke: "#6F9FE9",
    strokeWidth: 3,
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-1_11322_7928)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVat);
export default __webpack_public_path__ + "static/media/vat.466964b8.svg";
export { ForwardRef as ReactComponent };